import { Api } from "@/core/api.js";
const api = new Api();

// initial state
const state = {
  list: [],
  total_list: 0,
  pagination: { num_page: 0, num_items: 20 },
  current_filters: {}
};

// getters
const getters = {
  getList: (state, getters, rootState, rootGetters) => type => {
    var aGroups = [];
    var categories = rootGetters["events/getCurrentEvent"]().categories;
    for (var i in state.list) {
      if (state.list[i].visible) {
        var phase = rootGetters["competition/getListPhases"](
          state.list[i].phase_id
        );
        aGroups.push({
          id: state.list[i].id,
          name:
            categories[state.list[i].category_id].max_age +
            " - " +
            state.list[i].name +
            " (" +
            state.list[i].max_teams +
            ")",
          max_teams: state.list[i].max_teams,
          type: "category"
        });

        for (var key in state.list[i].teams) {
          var team = state.list[i].teams[key];

          aGroups.push({
            id: "tt" + team.id,
            group: state.list[i].name,
            name: team.name,
            team: team.team,
            position: team.position,
            category: categories[state.list[i].category_id].max_age,
            category_id: state.list[i].category_id
          });
        }
      }
    }
    return aGroups;
  },

  getTotalList: (state, getters, rootState) => () => {
    return state.total_list;
  },

  getListNoFiltered: (state, getters, rootState) => type => {
    var aClubs = [];
    for (var i in state.list) {
      if (state.list[i].visible) aClubs.push(state.list[i]);
    }
    return aClubs;
  },

  getTmplTeams: (state, getters, rootState) => id => {
    if (typeof id !== "undefined") return state.list[id].teams;
    var aTmplTeams = [];
    for (var i in state.list) {
      if (state.list[i].visible) {
        for (var key in state.list[i].teams) {
          var team = state.list[i].teams[key];

          aTmplTeams[team.id] = {
            id: team.id,
            group: state.list[i].name,
            name: team.name,
            team: team.team,
            position: team.position
          };
        }
      }
    }

    return aTmplTeams;
  }
};

// actions
const actions = {
  loadList({ commit, dispatch, getters, rootState, state }, params) {
    //TODO load phases competition!
    return dispatch("competition/loadPhases", params, { root: true }).then(
      function(response) {
        var path = "competition/group/event/" + params.event;
        var page_options =
          params && params.page_options
            ? params.page_options
            : state.pagination;
        var filters = state.current_filters;
        filters =
          params && params.filters
            ? Object.assign(filters, params.filters)
            : filters;
        var oParams = Object.assign(filters ? filters : {}, page_options);
        return api.post(path, oParams).then(function(response) {
          if (response.status) {
            var data = response.data.data;
            for (var i in data) {
              data[i].visible = true;
              data[i].type = "category";
            }

            commit("setList", { data: data, total: response.data.total });
            return commit("setPagination", page_options);
          }
        });
      }
    );
  },

  updateGroup(context, params) {
    return api
      .post("competition/group/edit/" + params.id + "/" + params.event_id, {
        checking: params.checking
      })
      .then(function(response) {
        return response;
      });
  }
};

// mutations
const mutations = {
  setList(state, data) {
    state.list = data.data;
    state.total_list = data.total;
  },

  applyFilters(state, filters) {
    state.current_filters = filters;
    // var list = { ...state.list };
    // if (!filters) {
    //   for (var i in list) {
    //     list[i].visible = true;
    //   }
    // } else {
    //   for (var i in list) {
    //     list[i].visible = false;
    //   }
    //   for (var i in list) {
    //     var item = list[i];
    //     // console.log( " ---- ITEM " + item.name + " --- " );
    //     var bFound = true;
    //     for (var k in filters) {
    //       // console.log( "--- KEY: " + k + " ---" )
    //       if (filters[k] != -1) {
    //         var item_value =
    //           item[k] != null && typeof item[k] == "object"
    //             ? item[k].id
    //             : item[k];
    //         if (
    //           item.hasOwnProperty(k) &&
    //           filters[k] == null &&
    //           item_value == null
    //         ) {
    //         } else {
    //           // console.log( "KEY SEARCH: " + k + " ITEM: " + item_value + " - FILTER: " + filters[k] + " " + typeof filters[k] );
    //           // filters[k] = filters[k] == null ? null : ( typeof filters[k] !== 'string' ? ( typeof filters[k] !== 'boolean' ? ( filters[k] ? 1 : 0 ) : filters[k] ) : filters[k].trim() )

    //           if (filters[k] != null && typeof filters[k] === "boolean")
    //             filters[k] = filters[k] ? 1 : 0;
    //           else if (filters[k] != null && typeof filters[k] === "string")
    //             filters[k] = filters[k].trim();

    //           // console.log( "KEY SEARCH: " + k + " ITEM: " + item_value + " - FILTER: " + filters[k] + " " + typeof filters[k] );
    //           var regexp = new RegExp(filters[k], "gi");

    //           if (
    //             item.hasOwnProperty(k) &&
    //             typeof item[k] == "object" &&
    //             filters[k] != item_value
    //           ) {
    //             bFound = false;
    //           } else if (
    //             item.hasOwnProperty(k) &&
    //             typeof item[k] !== "object" &&
    //             !item_value.match(regexp)
    //           ) {
    //             bFound = false;
    //           } else if (
    //             item.hasOwnProperty("phase_id") &&
    //             k == "category" &&
    //             filters[k] != item.phase_id
    //           ) {
    //             bFound = false;
    //           }
    //         }
    //       }
    //     }

    //     list[i].visible = bFound;
    //   }
    // }

    // state.list = list;
  },
  setPagination(state, value) {
    state.pagination = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
